import { QueryKey, useQuery, UseQueryOptions } from "react-query";
import { SUPPLIERS_ENDPOINT } from "./constants";
import useFetchWithAuth from "@/fetch/fetchWithAuth";
import { useCurrentTrip } from "@/hooks";

export enum INTERVIEW_STATUS {
  PLACED = "Placed",
  ACTIVE = "Active",
  MISSED = "Missed",
  UNSUCCESSFUL = "Unsuccessful",
  INACTIVE = "Inactive",
  NO_SHOW = "No Show",
  CANCELLED = "Cancelled",
  DECLINED_AFTER_THE_INTERVIEW = "Declined after the interview",
  DECLINED_PRE_INTERVIEW = "Declined Pre-interview",
}

export type InterviewItem = {
  id: number;
  organized_by_partner: number;
  traveller_time_zone: string;
  traveller_time_zone_display: string;
  interviewer: string;
  interview_date: string;
  interview_time: string;
  status: INTERVIEW_STATUS;
  address: string;
  website: string;
  phone: string;
  partner_name: string;
  sub_role: string;
  job_start_date: string;
  interview_method: string;
  role: string;
  job_dates: Array<{ start_date: number; end_date: number }>;
};

type Result = Partial<{
  offered: Array<InterviewItem>;
  active: Array<InterviewItem>;
  inactive: Array<InterviewItem>;
}>;

type QueryError = {};

type Variables = {
  status: "Applied" | "Offered";
};

const useInterviewsQuery = (
  variables: Variables,
  options?: UseQueryOptions<Result, QueryError, Result, QueryKey>
) => {
  const { currentTrip } = useCurrentTrip();
  const tid = currentTrip?.id;
  const url = `${SUPPLIERS_ENDPOINT}/interviews`;
  const { fetchWithAuth } = useFetchWithAuth();
  const cacheKey = [url, tid, JSON.stringify(variables)];

  return useQuery<Result, QueryError>(
    cacheKey,
    async () => {
      const params: any = {
        ...Object.fromEntries(
          Object.entries(variables).filter(([key, value]) => Boolean(value))
        ),
      };

      const res = await fetchWithAuth<Result>(url, {
        params: {
          tid: tid,
          ...params,
        },
      });
      return res;
    },
    {
      enabled: !!tid,
      ...options,
    }
  );
};
export default useInterviewsQuery;
